import React, { useState } from 'react'
import {
  GestureResponderEvent,
  NativeSyntheticEvent,
  Platform,
  StyleSheet,
  TargetedEvent,
  TouchableOpacity,
  TouchableOpacityProps,
  ViewStyle,
} from 'react-native'

import { Color } from '../../style'
import { Icon } from '../icon'

const styles = StyleSheet.create({
  active: {
    color: Color.greyBlue,
  },
})

interface Props extends TouchableOpacityProps {
  onChange?: (value: boolean) => void
  value?: boolean
}
const SecureIcon = (props: Props) => {
  const { style, value, onChange, onPress, onFocus, onBlur, ...otherProps } = props
  const [active, setActive] = useState(false)

  const updateActive = (value: boolean) => (event: NativeSyntheticEvent<TargetedEvent>) => {
    setActive(value)
    value && onFocus && onFocus(event)
    !value && onBlur && onBlur(event)
  }

  const change = (event: GestureResponderEvent) => {
    onChange && onChange(!value)
    onPress && onPress(event)
  }

  return (
    <TouchableOpacity
      onPress={change}
      style={[
        style,
        Platform.select({
          // @ts-expect-error outline style none is not defined
          web: {
            outlineStyle: 'none',
          } as ViewStyle,
        }),
      ]}
      onFocus={updateActive(true)}
      onBlur={updateActive(false)}
      {...otherProps}
    >
      <Icon name={value ? 'eyeClosed' : 'eyeOpen'} size={33} style={active && styles.active} />
    </TouchableOpacity>
  )
}

export default SecureIcon
